import ga_config from './ga-config';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', ga_config.tracking_id, { 'anonymize_ip': true });
